import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, DestroyRef, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, of, isObservable } from 'rxjs';
import { SelectData } from '@shared/models/select-input.model';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { ZSelectComponent } from '../z-select/z-select.component';
import { ZInputComponent } from '../z-input/z-input.component';

export interface FilterConfig {
    key: string;
    label: string;
    options?: SelectData[] | Observable<SelectData[]>;
    placeholder?: string;
    col?: string;
    type: 'select' | 'input' | 'date';
}

@Component({
    selector: 'z-filter-bar',
    templateUrl: './z-filter-bar.component.html',
    styleUrls: ['./z-filter-bar.component.scss'],
    imports: [ReactiveFormsModule, NgFor, NgIf, ZSelectComponent, ZInputComponent, AsyncPipe]
})
export class ZFilterBarComponent implements OnInit, OnChanges {
    @Input() filters: FilterConfig[] = [];
    @Output() filterChange = new EventEmitter<{ [key: string]: any }>();

    filterForm: FormGroup;
    private destroyRef = inject(DestroyRef);

    constructor(private fb: FormBuilder) {
        this.filterForm = this.fb.group({});
    }

    ngOnInit(): void {
        this.initForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filters'] && !changes['filters'].firstChange) {
            this.initForm();
        }
    }

    private initForm() {
        // Clear existing controls if needed (simple approach: recreate group or remove controls)
        // For simplicity reusing existing group if empty, but safer to match keys
        this.filters.forEach(filter => {
            if (!this.filterForm.contains(filter.key)) {
                this.filterForm.addControl(filter.key, this.fb.control(null));
            }
        });

        // Listen to changes
        this.filterForm.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(values => {
                this.filterChange.emit(values);
            });
    }

    getOptionsObservable(filter: FilterConfig): Observable<SelectData[]> {
        if (!filter.options) {
            return of([]);
        }
        if (isObservable(filter.options)) {
            return filter.options;
        }
        return of(filter.options);
    }
}
